import React, { useEffect, useState } from 'react';
import { ConfigClientType } from '../types/ConfigClientType';

type WcbDateSelectProps = {
    iimclient: ConfigClientType;
    wcbDates: Array<string>;
    changeSelectedDate: Function;
};

const WcbDateSelect = ({ iimclient, wcbDates, changeSelectedDate }: WcbDateSelectProps) => {
    const { segment } = iimclient;

    const initialDate = wcbDates.length ? wcbDates[0] : '';
    const [selectedDate, setSelectedDate] = useState(initialDate);

    useEffect(() => {
      if (initialDate !== '') {
        setSelectedDate(initialDate);
        changeSelectedDate(initialDate);
      }
    }, [wcbDates]);

    const handleChange = ({ target }) => {
      setSelectedDate(target.value);
      changeSelectedDate(target.value);
    }

    const label = segment.labelnodateselected || 'labelnodateselected'

    // Not sure how to think about this, if it's expected to be a list, empty list maps onto empty list so probably not needed
    const datesVisible = wcbDates.length > 0;

    const formatDate = (date: string) => date.split('-').reverse().join('.')

    return (
      <select
        name="wcb-date"
        id="wcb-date"
        className="if dropdown-select"
        aria-labelledby="wcb-labeldate"
        value={selectedDate}
        onChange={handleChange}
        >
        {datesVisible && (
          wcbDates.map((date, index) => (
            <option key={index} value={date}>
              {formatDate(date)}
            </option>
          ))
        )}
        {/* This had display disabled & hidden already, so just commenting it out to never render in the first place
          <option value="" disabled hidden>
            {label}
          </option>
        */}
      </select>
    );
};

export default WcbDateSelect;
